const cssReset = `
  * {
    box-sizing: border-box; /* Ensures padding and border are included in the total width and height of elements */
  }

  html, body {
    position: relative;
    margin: 0;
    padding: 0;
    line-height: 1.6;
    font-family: Arial, sans-serif; /* Fallback font family */
    min-height: 100vh;
  }

  h1, h2, h3, h4, h5, h6 {
    margin: 0;
    padding: 0;
  }

  a {
    color: inherit; /* Inherit color from parent element */
    text-decoration: none; /* Remove underline */
  }

  button {
    border: none;
    background: none;
    cursor: pointer;
  }
`;

const hartfordHomePage = `
  <div class="home">
    {{> hartford/Hero heroImageUrl=project.values.heroImageUrl }}

    <div class="cards-section">
      <div class="container">
        <div class="cards-row">
          {{#each pageContext.link_cards}}
            {{> hartford/LinkCard iconUrl=this.iconUrl linkUrl=this.url text=this.text}}
          {{/each}}
        </div>
      </div>
    </div>

    <div class="content-section">
      <div class="container">
        <h2 class="section-title">{{ project.values.galleryTitle }}</h2>
        <div class="section-subtitle">{{ project.values.gallerySubtitle }}</div>
        <div class="content-grid">
          <div class="gallery-area">
            {{> hartford/LinkGallery links=pageContext.gallery_links basePath=basePath }}
          </div>
          <div class="sidebar-area">
            {{> hartford/FileDownloadCard
              title=pageContext.presentation_download.[0].title
              thumbnailUrl=pageContext.presentation_download.[0].thumbnailUrl
              downloadUrl=pageContext.presentation_download.[0].downloadUrl
            }}
          </div>
        </div>
      </div>
    </div>

    <div class="team-section">
      <div class="container">
        <h2 class="section-title">{{ project.values.contactsTitle }}</h2>
        <div class="section-subtitle">{{ project.values.contactsSubtitle }}</div>
        <div class="team-row">
          {{#each pageContext.contacts}}
            <div class="team-member">
              <div class="member-photo">
                <img src="{{this.photo_url}}" alt="{{this.name}}" />
              </div>
              <h3 class="member-name">{{this.name}}</h3>
              <div class="member-title">Chief Executive Officer</div>
              <a href="mailto:{{this.email}}" class="member-email">{{this.email}}</a>
            </div>
          {{/each}}
        </div>
      </div>
    </div>

    <div class="quote-section">
      <div class="container">
        <div class="quote-container">
          <div class="quote-mark">"</div>
          <blockquote class="quote-text">
            {{pageContext.quote.[0].quote}}
          </blockquote>
          <div class="quote-note">
            {{pageContext.quote.[0].note}}
          </div>
        </div>
      </div>
    </div>

    {{> hartford/Footer logoUrl=project.values.logoUrl }}
  </div>
`;

const hartfordHomePageStyles = `
${cssReset}

.home {
  background-color:rgb(248, 246, 241);
}

.section-title {
  font-size: 32px;
  font-weight: 700;
  color: #333;
  text-align: left;
  margin-bottom: 10px;
  position: relative;
}

.section-title:after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 0;
  width: 60px;
  height: 3px;
  background-color: #0066cc;
}

.section-subtitle {
  text-align: left;
  font-size: 18px;
  color: #666;
  max-width: 700px;
  margin: 20px 0;
}

.container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container {
    max-width: 540px;
  }
}

@media (min-width: 768px) {
  .container {
    max-width: 720px;
  }
}

@media (min-width: 992px) {
  .container {
    max-width: 960px;
  }
}

@media (min-width: 1200px) {
  .container {
    max-width: 1140px;
  }
}

/* Cards Section Styles */
.cards-section {
  padding: 60px 0;
  background-color: #ededed;
}

/* Content Section Styles */
.content-section {
  padding: 60px 0;
}

.content-grid {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 40px;
}

.gallery-area {
  /* Spans 2 columns */
}

.sidebar-area {
  /* Takes 1 column */
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.download-section {
  margin-top: 10px;
}

@media (max-width: 992px) {
  .content-grid {
    grid-template-columns: 1fr;
    gap: 30px;
  }
}

.cards-row {
  display: flex;
  gap: 24px;
  justify-content: center;
  align-items: stretch;
  margin: 0 -15px;
}

/* Team Section Styles */
.team-section {
  padding: 80px 0;
  background-color:rgb(255, 255, 255);
}

.team-row {
  display: flex;
  justify-content: center;
  gap: 30px;
  margin-top: 50px;
  padding-bottom: 20px;
}

.team-row::-webkit-scrollbar {
  height: 6px;
}

.team-row::-webkit-scrollbar-track {
  background: #f0f0f0;
  border-radius: 4px;
}

.team-row::-webkit-scrollbar-thumb {
  background-color: #0066cc;
  border-radius: 4px;
}

.team-member {
  flex: 0 0 250px;
  text-align: center;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.team-member:hover {
  transform: translateY(-10px);
}

.member-photo {
  display: block;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  overflow: hidden;
  margin: 0 auto 20px;
  background-color: #A1D6CB;
  transition: transform 0.3s ease;
}

.team-member:hover .member-photo {
  transform: scale(1.05);
}

.member-photo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.member-name {
  font-size: 20px;
  font-weight: 700;
  color: #333;
}

.member-title {
  font-size: 14px;
  color: #666;
}

.member-email {
  display: inline-block;
  color: #0066cc;
  font-size: 14px;
  text-decoration: none;
  transition: color 0.3s ease;
  position: relative;
}

.member-email:after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 0;
  height: 1px;
  background-color: #0066cc;
  transition: width 0.3s ease;
}

.member-email:hover {
  color: #004999;
}

.member-email:hover:after {
  width: 100%;
}

/* Quote Section Styles */
.quote-section {
  padding: 100px 0;
  position: relative;
  overflow: hidden;
}

.quote-container {
  max-width: 900px;
  margin: 0 auto;
  text-align: center;
  position: relative;
  padding: 40px 20px;
}

.quote-mark {
  font-size: 120px;
  line-height: 1;
  color: #FF9D23;
  font-family: Georgia, serif;
  position: absolute;
  top: -20px;
  left: 0;
  z-index: 0;
}

.quote-text {
  font-size: 32px;
  line-height: 1.4;
  color: #333;
  font-style: italic;
  margin: 0 0 30px;
  position: relative;
  z-index: 1;
  font-weight: 300;
}

.quote-note {
  font-size: 16px;
  color: #666;
  font-style: normal;
  position: relative;
  z-index: 1;
}

@media (max-width: 992px) {
  .team-row {
    flex-wrap: wrap;
    justify-content: center;
    padding-left: 10px;
    padding-right: 10px;
  }

  .quote-text {
    font-size: 28px;
  }
}

@media (max-width: 576px) {
  .team-section {
    padding: 60px 0;
  }

  .section-title {
    font-size: 28px;
  }

  .section-subtitle {
    font-size: 16px;
    margin: 25px auto;
  }

  .team-member {
    flex: 0 0 220px;
    padding: 25px 15px;
  }

  .member-photo {
    width: 100px;
    height: 100px;
  }

  .quote-section {
    padding: 70px 0;
  }

  .quote-text {
    font-size: 22px;
  }

  .quote-note {
    font-size: 14px;
  }
}
`;

const hartfordHero = `
  <section class="hero-section">
    <div class="hero-background">
      <div class="hero-shape hero-shape-1"></div>
      <div class="hero-shape hero-shape-2"></div>
      <div class="hero-shape hero-shape-3"></div>
      <div class="hero-lines"></div>
    </div>
    <div class="container hero-container">
      <div class="hero-content">
        <div class="hero-badge">Premium Partner</div>
        <h1 class="hero-title">Best partner for <span class="highlight">The Hartford</span></h1>
        <p class="hero-subtitle">Detailing the value proposition and strategic advantages</p>
        <div class="hero-decoration"></div>
      </div>
      <div class="hero-image">
        <div class="hero-image-wrapper">
          <img src="{{heroImageUrl}}" alt="The Hartford Partnership" />
        </div>
      </div>
    </div>
  </section>
`;

const hartfordHeroStyles = `
  .hero-section {
    background-color: #3a5a78;
    color: white;
    padding: 100px 0;
    position: relative;
    overflow: hidden;
  }

  .hero-background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  .hero-shape {
    position: absolute;
    border-radius: 50%;
    opacity: 0.1;
  }

  .hero-shape-1 {
    width: 400px;
    height: 400px;
    background: linear-gradient(135deg, #ffffff, #a3c2e0);
    top: -100px;
    left: -100px;
    animation: float 15s ease-in-out infinite;
  }

  .hero-shape-2 {
    width: 300px;
    height: 300px;
    background: linear-gradient(135deg, #ffffff, #a3c2e0);
    bottom: -150px;
    right: 10%;
    animation: float 18s ease-in-out infinite reverse;
  }

  .hero-shape-3 {
    width: 200px;
    height: 200px;
    background: linear-gradient(135deg, #ffffff, #a3c2e0);
    top: 20%;
    right: -50px;
    animation: float 12s ease-in-out infinite;
  }

  @keyframes float {
    0% { transform: translate(0, 0) rotate(0deg); }
    50% { transform: translate(15px, 15px) rotate(5deg); }
    100% { transform: translate(0, 0) rotate(0deg); }
  }

  .hero-lines {
    position: absolute;
    width: 100%;
    height: 100%;
    background-image:
      linear-gradient(90deg, rgba(255,255,255,0.07) 1px, transparent 1px),
      linear-gradient(rgba(255,255,255,0.07) 1px, transparent 1px);
    background-size: 50px 50px;
  }

  .hero-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    z-index: 2;
  }

  .hero-content {
    flex: 1;
    max-width: 600px;
    padding-right: 40px;
    position: relative;
  }

  .hero-badge {
    display: inline-block;
    background-color: rgba(255, 255, 255, 0.15);
    border: 1px solid rgba(255, 255, 255, 0.3);
    padding: 8px 16px;
    border-radius: 30px;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 1px;
    text-transform: uppercase;
    margin-bottom: 25px;
    backdrop-filter: blur(5px);
    animation: fadeIn 0.8s ease-out forwards;
  }

  .hero-title {
    font-size: 4.2rem;
    font-weight: 700;
    margin-bottom: 20px;
    line-height: 1.2;
    position: relative;
    animation: slideUp 0.8s ease-out forwards;
  }

  .hero-title .highlight {
    color: #FFD700;
    position: relative;
    display: inline-block;
  }

  .hero-title .highlight:after {
    content: '';
    position: absolute;
    bottom: -5px;
    left: 0;
    width: 100%;
    height: 3px;
    background-color: #FFD700;
    transform: scaleX(0.8);
    transform-origin: left;
    transition: transform 0.3s ease;
  }

  .hero-title .highlight:hover:after {
    transform: scaleX(1);
  }

  .hero-subtitle {
    font-size: 1.5rem;
    font-weight: 400;
    margin-bottom: 30px;
    opacity: 0;
    animation: slideUp 1s ease-out forwards;
    animation-delay: 0.2s;
  }

  .hero-decoration {
    position: absolute;
    bottom: -20px;
    left: 0;
    width: 80px;
    height: 4px;
    background: linear-gradient(90deg, #FFD700, rgba(255, 215, 0, 0.3));
    animation: expandWidth 1.2s ease-out forwards;
    animation-delay: 0.5s;
    transform-origin: left;
    transform: scaleX(0);
  }

  @keyframes expandWidth {
    from { transform: scaleX(0); }
    to { transform: scaleX(1); }
  }

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .hero-image {
    flex: 1;
    max-width: 500px;
    position: relative;
    animation: fadeIn 1.2s ease-out forwards;
    animation-delay: 0.3s;
    opacity: 0;
  }

  .hero-image-wrapper {
    position: relative;
    z-index: 1;
  }

  .hero-image img {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 10px;
    transition: transform 0.5s ease;
  }

  .hero-image-accent {
    position: absolute;
    top: 20px;
    left: 20px;
    width: 100%;
    height: 100%;
    border: 3px solid rgba(255, 215, 0, 0.3);
    border-radius: 10px;
    z-index: -1;
    transition: transform 0.5s ease;
  }

  .hero-image:hover img {
    transform: translate(-5px, -5px);
  }

  .hero-image:hover .hero-image-accent {
    transform: translate(5px, 5px);
  }

  @media (max-width: 992px) {
    .hero-container {
      flex-direction: column;
      text-align: center;
    }

    .hero-content {
      max-width: 100%;
      padding-right: 0;
      margin-bottom: 60px;
    }

    .hero-decoration {
      left: 50%;
      transform: translateX(-50%) scaleX(0);
    }

    @keyframes expandWidth {
      from { transform: translateX(-50%) scaleX(0); }
      to { transform: translateX(-50%) scaleX(1); }
    }

    .hero-title {
      font-size: 3.5rem;
    }

    .hero-image {
      max-width: 80%;
    }
  }

  @media (max-width: 576px) {
    .hero-section {
      padding: 80px 0;
    }

    .hero-title {
      font-size: 2.8rem;
    }

    .hero-subtitle {
      font-size: 1.3rem;
    }
  }
`;

const hartfordLinkCard = `
  <div class="link-card">
    <div class="link-card-icon">
      <div class="icon-wrapper">
        <img src="{{iconUrl}}" alt="{{text}} Icon" />
      </div>
      <div class="icon-glow"></div>
    </div>
    <div class="link-card-content">
      <h3 class="link-card-title">{{text}}</h3>
      <p class="link-card-description">Access valuable resources and information</p>
      <a href="{{linkUrl}}" class="link-card-link">
        <span>View now</span>
        <svg class="arrow-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="5" y1="12" x2="19" y2="12"></line>
          <polyline points="12 5 19 12 12 19"></polyline>
        </svg>
      </a>
    </div>
  </div>
`;

const hartfordLinkCardStyles = `
  .link-card {
    display: flex;
    background-color: #ffffff;
    border-radius: 12px;
    padding: 30px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
    transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
    max-width: 450px;
    position: relative;
    overflow: hidden;
    border: 1px solid rgba(0, 0, 0, 0.05);
  }

  .link-card:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, rgba(58, 90, 120, 0.03) 0%, rgba(58, 90, 120, 0) 50%);
    z-index: 0;
  }

  .link-card:hover {
    transform: translateY(-10px);
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.12);
    border-color: rgba(0, 102, 204, 0.2);
  }

  .link-card-icon {
    flex-shrink: 0;
    width: 90px;
    height: 90px;
    margin-right: 30px;
    position: relative;
    z-index: 1;
  }

  .icon-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(58, 90, 120, 0.05);
    border-radius: 50%;
    padding: 18px;
    transition: transform 0.5s ease;
    position: relative;
    z-index: 2;
  }

  .icon-glow {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    background: radial-gradient(circle, rgba(0, 102, 204, 0.2) 0%, rgba(0, 102, 204, 0) 70%);
    border-radius: 50%;
    opacity: 0;
    transition: opacity 0.5s ease;
    z-index: 1;
  }

  .link-card:hover .icon-wrapper {
    transform: scale(1.1);
  }

  .link-card:hover .icon-glow {
    opacity: 1;
    animation: pulse 2s infinite;
  }

  @keyframes pulse {
    0% { transform: translate(-50%, -50%) scale(0.8); opacity: 0.5; }
    50% { transform: translate(-50%, -50%) scale(1.1); opacity: 0.8; }
    100% { transform: translate(-50%, -50%) scale(0.8); opacity: 0.5; }
  }

  .link-card-icon img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    transition: transform 0.5s ease;
  }

  .link-card:hover .link-card-icon img {
    transform: scale(1.1);
  }

  .link-card-content {
    display: flex;
    flex-direction: column;
    flex: 1;
    position: relative;
    z-index: 1;
  }

  .link-card-title {
    font-size: 22px;
    font-weight: 700;
    color: #333;
    margin: 0 0 10px 0;
    transition: color 0.3s ease;
  }

  .link-card:hover .link-card-title {
    color: #0066cc;
  }

  .link-card-description {
    font-size: 15px;
    color: #666;
    margin: 0 0 15px 0;
    line-height: 1.5;
    flex-grow: 1;
  }

  .link-card-link {
    display: inline-flex;
    align-self: flex-start;
    align-items: center;
    color: #0066cc;
    font-weight: 600;
    text-decoration: none;
    font-size: 16px;
    transition: all 0.3s ease;
    position: relative;
  }

  .arrow-icon {
    margin-left: 8px;
    transition: transform 0.3s ease;
  }

  .link-card-link:hover {
    color: #004999;
  }

  .link-card-link:hover .arrow-icon {
    transform: translateX(5px);
  }

  .link-card-link:after {
    content: '';
    position: absolute;
    bottom: -2px;
    left: 0;
    width: 0;
    height: 2px;
    background-color: #0066cc;
    transition: width 0.3s ease;
  }

  .link-card-link:hover:after {
    width: calc(100% - 24px); /* Subtract the width of the arrow icon */
  }

  @media (max-width: 576px) {
    .link-card {
      flex-direction: column;
      text-align: center;
      padding: 25px;
    }

    .link-card-icon {
      margin-right: 0;
      margin-bottom: 20px;
    }

    .link-card-link:after {
      left: 50%;
      transform: translateX(-50%);
    }

    .link-card-link:hover:after {
      width: 80px;
    }
  }
`;

const hartfordLinkGallery = `
  <div class="link-gallery">
    <div class="link-gallery-grid">
      {{#each links}}
        <a href="{{../basePath}}{{this.url}}" class="gallery-item">
          <div class="gallery-icon">
            <div class="icon-circle">
              <img src="{{this.iconUrl}}" alt="{{this.text}} Icon" />
            </div>
          </div>
          <div class="gallery-content">
            <div class="gallery-text">{{this.text}}</div>
            <div class="gallery-arrow">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M5 12h14"></path>
                <path d="M12 5l7 7-7 7"></path>
              </svg>
            </div>
          </div>
        </a>
      {{/each}}
    </div>
  </div>
`;

const hartfordLinkGalleryV2 = `
  <div class="link-gallery">
    <div class="link-gallery-grid">
      {{#each links}}
        {{> hartford/GalleryLinkItem basePath=../basePath url=this.url iconUrl=this.iconUrl text=this.text}}
      {{/each}}
    </div>
  </div>
`;

const hartfordGalleryLinkItem = `
<a href="{{basePath}}{{url}}" class="gallery-item">
  <div class="gallery-icon">
    <div class="icon-circle">
      <img src="{{iconUrl}}" alt="{{text}} Icon" />
    </div>
  </div>
  <div class="gallery-content">
    <div class="gallery-text">{{text}}</div>
    <div class="gallery-arrow">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M5 12h14"></path>
        <path d="M12 5l7 7-7 7"></path>
      </svg>
    </div>
  </div>
</a>
`;

const hartfordLinkGalleryStyles = `
  .link-gallery {
    padding: 20px 0;
  }

  .link-gallery-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 25px; /* Equal gap for both directions */
  }

  .gallery-item {
    display: flex;
    align-items: center;
    padding: 20px 25px;
    background-color: #ffffff;
    border-radius: 10px;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);
    text-decoration: none;
    transition: all 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);
    border: 1px solid rgba(0, 0, 0, 0.05);
    position: relative;
    overflow: hidden;
  }

  .gallery-item:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, rgba(0, 102, 204, 0.03) 0%, rgba(0, 102, 204, 0) 60%);
    z-index: 0;
  }

  .gallery-item:hover {
    transform: translateY(-5px);
    box-shadow: 0 12px 30px rgba(0, 102, 204, 0.1);
    border-color: rgba(0, 102, 204, 0.2);
  }

  .gallery-icon {
    flex-shrink: 0;
    margin-right: 20px;
    position: relative;
    z-index: 1;
  }

  .icon-circle {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background-color: rgba(0, 102, 204, 0.08);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
  }

  .icon-circle:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: radial-gradient(circle at center, rgba(0, 102, 204, 0.2) 0%, rgba(0, 102, 204, 0) 70%);
    opacity: 0;
    transition: opacity 0.3s ease;
  }

  .gallery-item:hover .icon-circle {
    transform: scale(1.1);
    background-color: rgba(0, 102, 204, 0.12);
  }

  .gallery-item:hover .icon-circle:after {
    opacity: 1;
  }

  .gallery-icon img {
    width: 30px;
    height: 30px;
    object-fit: contain;
    transition: transform 0.3s ease;
    position: relative;
    z-index: 2;
  }

  .gallery-item:hover .gallery-icon img {
    transform: scale(1.1);
  }

  .gallery-content {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    z-index: 1;
  }

  .gallery-text {
    font-size: 18px;
    font-weight: 700;
    color: #0066cc;
    transition: color 0.3s ease;
  }

  .gallery-item:hover .gallery-text {
    color: #004999;
  }

  .gallery-arrow {
    color: #0066cc;
    opacity: 0.7;
    transition: all 0.3s ease;
    transform: translateX(-5px);
    opacity: 0;
  }

  .gallery-item:hover .gallery-arrow {
    transform: translateX(0);
    opacity: 1;
  }

  @media (max-width: 768px) {
    .link-gallery-grid {
      grid-template-columns: 1fr;
      gap: 20px;
    }
  }
`;

const hartfordFileDownloadCard = `
  <div class="file-download-card">
    <div class="download-card-header">
      <div class="download-card-badge">Presentation</div>
      <h3 class="download-card-title">{{title}}</h3>
      <div class="download-card-info">
        <div class="file-info">
          <svg class="file-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
            <polyline points="14 2 14 8 20 8"></polyline>
            <line x1="16" y1="13" x2="8" y2="13"></line>
            <line x1="16" y1="17" x2="8" y2="17"></line>
            <polyline points="10 9 9 9 8 9"></polyline>
          </svg>
          <span>PDF Document</span>
        </div>
        <div class="file-size">2.4 MB</div>
      </div>
    </div>
    <div class="download-card-thumbnail">
      <div class="thumbnail-wrapper">
        <img src="{{thumbnailUrl}}" alt="{{title}} Thumbnail" />
        <div class="thumbnail-overlay">
          <div class="overlay-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <polygon points="10 8 16 12 10 16 10 8"></polygon>
            </svg>
          </div>
        </div>
      </div>
    </div>
    <a href="{{downloadUrl}}" class="download-button" download>
      <span class="download-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
          <polyline points="7 10 12 15 17 10"></polyline>
          <line x1="12" y1="15" x2="12" y2="3"></line>
        </svg>
      </span>
      Download Presentation
    </a>
  </div>
`;

const hartfordFileDownloadCardStyles = `
  .file-download-card {
    background-color: #ffffff;
    border-radius: 12px;
    padding: 30px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
    display: flex;
    flex-direction: column;
    border: 1px solid rgba(0, 0, 0, 0.05);
    transition: transform 0.4s cubic-bezier(0.165, 0.84, 0.44, 1), box-shadow 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
    max-width: 350px;
    margin: 0 auto;
  }

  .file-download-card:hover {
    transform: translateY(-10px);
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.12);
    border-color: rgba(0, 102, 204, 0.2);
  }

  .download-card-header {
    margin-bottom: 20px;
  }

  .download-card-badge {
    display: inline-block;
    background-color: rgba(0, 102, 204, 0.1);
    color: #0066cc;
    font-size: 12px;
    font-weight: 600;
    padding: 5px 10px;
    border-radius: 20px;
    margin-bottom: 10px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .download-card-title {
    font-size: 22px;
    font-weight: 700;
    color: #333;
    margin: 0 0 15px 0;
    line-height: 1.3;
  }

  .download-card-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    color: #666;
  }

  .file-info {
    display: flex;
    align-items: center;
  }

  .file-icon {
    margin-right: 6px;
    color: #0066cc;
  }

  .file-size {
    font-weight: 600;
  }

  .download-card-thumbnail {
    margin-bottom: 25px;
    border-radius: 8px;
    overflow: hidden;
    position: relative;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  }

  .thumbnail-wrapper {
    position: relative;
    overflow: hidden;
    transition: transform 0.5s ease;
  }

  .download-card-thumbnail img {
    width: 100%;
    height: auto;
    display: block;
    transition: transform 0.5s ease;
  }

  .thumbnail-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.5s ease;
  }

  .overlay-icon {
    color: white;
    background-color: rgba(0, 102, 204, 0.8);
    width: 60px;
    height: 60px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: scale(0.8);
    transition: transform 0.5s ease;
  }

  .file-download-card:hover .thumbnail-overlay {
    opacity: 1;
  }

  .file-download-card:hover .overlay-icon {
    transform: scale(1);
  }

  .file-download-card:hover .download-card-thumbnail img {
    transform: scale(1.05);
  }

  .download-button {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #0066cc;
    color: white;
    font-weight: 600;
    padding: 14px 20px;
    border-radius: 8px;
    text-decoration: none;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
    z-index: 1;
  }

  .download-button:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to right, #0066cc, #0052a3);
    z-index: -1;
    transition: opacity 0.3s ease;
    opacity: 0;
  }

  .download-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(0, 102, 204, 0.3);
  }

  .download-button:hover:before {
    opacity: 1;
  }

  .download-icon {
    margin-right: 10px;
    display: flex;
    align-items: center;
    transition: transform 0.3s ease;
  }

  .download-button:hover .download-icon {
    transform: translateY(2px);
  }
`;

export const homeBlocks: any[] = [
  {
    name: 'hartford/HomePage',
    partial: hartfordHomePage,
    css: hartfordHomePageStyles,
  },
  {
    name: 'hartford/Hero',
    partial: hartfordHero,
    css: hartfordHeroStyles,
  },
  {
    name: 'hartford/LinkCard',
    partial: hartfordLinkCard,
    css: hartfordLinkCardStyles,
  },
  {
    name: 'hartford/LinkGallery',
    partial: hartfordLinkGallery,
    css: hartfordLinkGalleryStyles,
  },
  {
    name: 'hartford/LinkGalleryV2',
    partial: hartfordLinkGalleryV2,
    css: hartfordLinkGalleryStyles,
  },
  {
    name: 'hartford/GalleryLinkItem',
    partial: hartfordGalleryLinkItem,
    css: hartfordLinkGalleryStyles,
  },
  {
    name: 'hartford/FileDownloadCard',
    partial: hartfordFileDownloadCard,
    css: hartfordFileDownloadCardStyles,
  },
];
